import { getData as apiGetData } from 'api/Api'
import {
  addArray as addUsersArray
} from 'store/redux/users'
import {
  refresh as refreshUsers,
  setLoadStatus,
  setOnlyActiveLoadStatus,
  setCursor,
  setOnlyActiveCursor,
  addArray as addUsersToView
} from '../redux/users'

type Payload = {
  boardId: number
  refresh?: boolean
  onlyActive?: boolean
  limit?: number
}

type BoardUsersArgs = {
  boardId: number
  limit?: number
  cursor: any
  active?: boolean
}

export default (payload: Payload) => async (dispatch, getState) => {
  const {
    boardId,
    refresh,
    onlyActive,
    limit = 50
  } = payload

  const state = getState()

  let cursor = state['view-board'].users[boardId].cursor
  let setLoadStatusMethod = setLoadStatus
  let setCursorMethod = setCursor
  if (onlyActive) {
    cursor = state['view-board'].users[boardId].onlyActiveCursor
    setLoadStatusMethod = setOnlyActiveLoadStatus
    setCursorMethod = setOnlyActiveCursor
  }

  const batchedActions: any[] = []

  if (refresh) {
    batchedActions.push(refreshUsers({
      boardId
    }))
  }

  batchedActions.push(setLoadStatusMethod({
    boardId,
    loading: true,
    loaded: false
  }))

  dispatch(batchedActions)

  const args: BoardUsersArgs = {
    boardId,
    limit,
    cursor
  }

  if (onlyActive) {
    args.active = true
  }

  try {
    const { Users, Cursor } = await apiGetData('BoardUsers', args)

    const batchedActions = [
      addUsersArray(Users.map(User => ({
        id: User.Id,
        name: User.Name,
        email: User.Email,
        profileKey: User.ProfileKey,
        licenseType: User.LicenseType,
        isActive: User.Active,
        isLoaded: true,
        isLoading: false
      }))),
      addUsersToView({
        boardId,
        array: Users.map(User => ({
          id: User.Id,
          permissionLevel: User.PermissionLevel
        }))
      }),
      setLoadStatusMethod({
        boardId,
        loading: false,
        loaded: !Cursor
      })
    ]

    if (Cursor) { // Don't set null cursor, because we need last used cursor
      batchedActions.push(setCursorMethod({
        boardId,
        cursor: Cursor
      }))
    }

    dispatch(batchedActions)
  } catch (error) {
    dispatch(setLoadStatusMethod({
      boardId,
      loading: false,
      loaded: false
    }))
  }
}
